/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type FlashOffersList_lists$ref = any;
export type FlashOffersListQueryVariables = {||};
export type FlashOffersListQueryResponse = {|
  +lists: ?{|
    +$fragmentRefs: FlashOffersList_lists$ref
  |}
|};
export type FlashOffersListQuery = {|
  variables: FlashOffersListQueryVariables,
  response: FlashOffersListQueryResponse,
|};
*/


/*
query FlashOffersListQuery {
  lists {
    ...FlashOffersList_lists
    id
  }
}

fragment FlashOfferCell_offer on Offer {
  id
  title
  startDate
  endDate
  store {
    name
    id
  }
}

fragment FlashOffersList_lists on Lists {
  flashOffers(first: 50) {
    edges {
      node {
        id
        ...FlashOfferCell_offer
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FlashOffersListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FlashOffersList_lists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FlashOffersListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 50
              }
            ],
            "concreteType": "OfferConnection",
            "kind": "LinkedField",
            "name": "flashOffers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OfferEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Offer",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Store",
                        "kind": "LinkedField",
                        "name": "store",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "flashOffers(first:50)"
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "FlashOffersListQuery",
    "operationKind": "query",
    "text": "query FlashOffersListQuery {\n  lists {\n    ...FlashOffersList_lists\n    id\n  }\n}\n\nfragment FlashOfferCell_offer on Offer {\n  id\n  title\n  startDate\n  endDate\n  store {\n    name\n    id\n  }\n}\n\nfragment FlashOffersList_lists on Lists {\n  flashOffers(first: 50) {\n    edges {\n      node {\n        id\n        ...FlashOfferCell_offer\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dabbd8f25b7fdc738ea324b55c13dbe1';

module.exports = node;
